import { ajax } from "rxjs/ajax";
import DOMPurify from "dompurify";
import shorten from "@fiquu/shorten";
import { DateTime } from "luxon";
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import 'animate.css';

export {
  of,
  map,
  catchError,
  shorten,
  ajax,
  DOMPurify,
  DateTime
}